import { isFunction, isObject, isUndefined } from 'lodash-es';

import { isNullOrUndefined } from './types.utils';

/**
 * Sorts an array of objects by property
 * @param prop The property to sort by
 * @param modifier Modify the property into something else if you want
 * @returns A Function to allow sorting an iterable
 */
export function sortByProperty(prop: string, modifier?: (value: any) => number) {
	return (a, b): number => {
		if (!a && !b) {
			return 0;
		} else if (!b && isObject(a)) {
			return 1;
		} else if (!a && isObject(b)) {
			return -1;
		} else {
			let aProp = a[prop];
			let bProp = b[prop];

			if (isFunction(modifier)) {
				aProp = modifier(aProp);
				bProp = modifier(bProp);
			}

			return aProp < bProp ? -1 : aProp > bProp ? 1 : 0;
		}
	};
}

export function wrapObjectToArray(data): any[] {
	if (Array.isArray(data)) {
		return data;
	} else if (!isNullOrUndefined(data) && !isNaN(data)) {
		return [data];
	}
	return [];
}
